export const round = (n, places = 3) => {
  const decimalPlaces = [1, 10, 100, 1000];
  const amount = decimalPlaces[places];
  return parseFloat((Math.round(n * amount) / amount).toFixed(places));
};
export const toValorantSens = (s) => round(s / 3.18181818);
export const toCsgoSens = (s) => round(s * 3.18181818);
export const toEdpi = (s, dpi) => round(s * dpi);
export const toCm360 = (edpi) => ((360 / (edpi * 0.022)) * 2.54).toFixed(0);
